import SidebarStandard from '../../components/sidebars/SidebarStandard.vue';

export default {
  computed: {
    sidebarContent() {
      return {
        title: {
          description: 'Biobank Registry',
          icon: 'mdi-flask-outline',
          link: 'MedicalCaseList',
        },
        items: [
          {
            title: 'Preparation',
            icon: 'mdi-shape-outline',
            link: 'specimen-state.list',
          },
          {
            title: 'Specimen Type',
            icon: 'mdi-flask-outline',
            link: 'specimen-type.list',
          },
          {
            title: 'Method of Collection',
            icon: 'mdi-medical-cotton-swab',
            link: 'method-of-collection.list',
          },
          {
            title: 'Freezer',
            icon: 'mdi-fridge-outline',
            link: 'freezer.list',
          },
          {
            title: 'Box',
            icon: 'mdi-apps-box',
            link: 'box.list',
          },
          {
            title: 'Specimen Additional Info',
            icon: 'mdi-help-box-outline',
            link: 'specimenAdditionalInfo.list',
          },
          {
            title: 'Case',
            icon: 'mdi-stethoscope',
            link: 'bcase.list',
          },
          {
            title: 'Specimen',
            icon: 'mdi-test-tube',
            link: 'specimen.list',
          },
        ],
      };
    },
  },
  components: {
    SidebarStandard,
  },
};
